var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88208,
    cy: 7.88208,
    r: 7.88208,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.47418 7.88188C1.47418 4.34285 4.34314 1.47389 7.88217 1.47389C11.4212 1.47389 14.2902 4.34285 14.2902 7.88188C14.2902 11.4209 11.4212 14.2899 7.88217 14.2899C4.34314 14.2899 1.47418 11.4209 1.47418 7.88188ZM7.88201 3.47642C8.32439 3.47642 8.68301 3.81263 8.68301 4.22736L8.68301 8.73298C8.68301 9.14771 8.32439 9.48391 7.88201 9.48391C7.43963 9.48391 7.08101 9.14771 7.08101 8.73298L7.08101 4.22736C7.08101 3.81263 7.43963 3.47642 7.88201 3.47642ZM8.68301 11.4864C8.68301 11.044 8.32439 10.6854 7.88201 10.6854C7.43963 10.6854 7.08101 11.044 7.08101 11.4864C7.08101 11.9288 7.43963 12.2874 7.88201 12.2874C8.32439 12.2874 8.68301 11.9288 8.68301 11.4864Z",
    fill: "#F97E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.7202f5b369610bd715c9425bb43ac791.svg";
export { ForwardRef as ReactComponent };